import styled from 'styled-components';

const defaultSize = 1.3;

export const Badge = styled.span`
    line-height: initial;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.intent.brand};
    color: ${({ theme }) => theme.colors.fixed.white};
    width: ${({ size = defaultSize }) => `${size}rem`};
    height: ${({ size = defaultSize }) => `${size}rem`};
    line-height: ${({ size = defaultSize }) => `${size}rem`};
`;
